const dns_select_template_dialog = {
	autocomplete: {
		label: "DNS-Vorlage",
	},
	description:
		"Wählen Sie eine vorhandene DNS-Vorlage aus, deren DNS-Einträge Sie verwenden möchten. Die ausgewählten DNS-Einträge werden der Liste der aktuellen DNS-Einträge hinzugefügt. Die DNS-Einträge, die derzeit in der Vorlage enthalten sind, werden daher nicht durch die ausgewählten DNS-Einträge überschrieben.",
	submit_button: {
		label: "Hinzufügen ({{record_selected_count}} Datensätze)",
	},
	success_message: "Die DNS-Vorlagen wurden erfolgreich hinzugefügt.",
	title: "DNS-Vorlage auswählen",
};

export default dns_select_template_dialog;
